import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import './_common/styles/calendar.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ModalsProvider } from '@mantine/modals';
import { ThemeContext } from '@emotion/react';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <ModalsProvider>
        <App />
    </ModalsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
